// Basic
import PropTypes from 'prop-types';
// Libs
import { useNavigate } from 'react-router-dom';
// Components
import ChartCard from '@/common-utils/components/renders/chartsCards/ChartCard';
import PieChartSkeleton from '../../common/PieChartSkeleton';
import CardRedirection from '../../common/CardRedirection';
import PieChartCustom from '@/common-utils/components/renders/charts/PieChartCustom';
// Common
import CONTRACTS_STATS_FIELDS from '../../../fields/ContractsStatsFields';
import RouteUrls from '@/app/root/enums/RouteUrls';
// Lang
import { nsDashboard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.dashboardData
 * @returns {JSX} ContractsCbVersionsChart
 */
function ContractsCbVersionsChart({ dashboardData }) {

    // Hooks
    const navigate = useNavigate();

    return (
        <>
            {dashboardData.contracts?.isFetching &&
                <PieChartSkeleton />
            }
            {!dashboardData.contracts?.isFetching && (
                <ChartCard
                    title='charts.contracts.cb_versions.title'
                    tooltipEntity='charts.contracts.cb_versions.tooltip'
                    namespace={nsDashboard}
                >
                    {dashboardData.contracts?.data && !dashboardData.contracts?.error && (
                        <PieChartCustom
                            data={dashboardData.contracts?.data}
                            dataKey={CONTRACTS_STATS_FIELDS.CB_VERSION_BREAKDOWN.key}
                            chartKey='cbVersion'
                            valueKey='count'
                            namespace={nsDashboard}
                        />
                    )}
                    {dashboardData.contracts?.error && (
                        <CardRedirection
                            buttonEntity='redirection.contracts'
                            namespace={nsDashboard}
                            onClick={() => { navigate(RouteUrls.SEARCH_CONTRACTS.url); }}
                        />
                    )}
                </ChartCard>
            )}
        </>
    );
}

ContractsCbVersionsChart.propTypes = {
    dashboardData: PropTypes.object.isRequired
};

export default ContractsCbVersionsChart;